import React, { Component } from 'react';

class SamplePackNameComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
              <input                  
                onChange={e => this.props.onNameChanged(e.target.value)}
                value={this.props.name}
                placeholder="Type name here"
                className='tags-input sample-pack-input'
                type="text"/>
                <div className="info-text">
                  {this.props.editingExisting ? '... editing existing' : ''}
                </div>
            </div>
        );
    }
}
                
export default SamplePackNameComponent;
